import PadraoModel from 'src/core/model/PadraoModel.js'

export default class UsadosbrCambioModel extends PadraoModel {
  recurso = 'usadosbr/cambios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Câmbios Usadosbr';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
